import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

import CustomButton from "Components/Commons/CustomButton/CustomButton";

import { ReactComponent as HeaderLogo } from "../../Assets/Images/LandingPage/subjects-master-logo.svg";
import { ReactComponent as FacebookIcon } from "../../Assets/Images/Header/Facebook.svg";
import { ReactComponent as InstaIcon } from "../../Assets/Images/Header/Instagram.svg";
import { ReactComponent as TiktokIcon } from "../../Assets/Images/Header/TikTok.svg";
import { SOCIAL_MEDIA_LINKS, URL_GENERAL_DASHBOARD, URL_LOGIN } from "Helpers";
import { HeaderContainer } from "./Header.style";

const Header = () => {
	const navigate = useNavigate();
	const isLoggedIn = useSelector((state) => state.Auth.isLoggedIn);

	const handleLoginClick = () => {
		navigate(isLoggedIn ? URL_GENERAL_DASHBOARD : URL_LOGIN);
	};

	const menuItems = [
		{ name: "Home", path: "/" },
		{ name: "About Us", path: "/about-us" },
		{ name: "Subjects", path: "/subjects" },
		{ name: "Subscription Plan", path: "/subscription" },
		{ name: "Testimonials", path: "/testimonials" },
		{ name: "Contact Us", path: "/contact-us" },
	];

	return (
		<HeaderContainer className="mains_header">
			<div className="mygrid-container">
				<div className="mygrid-row" style={{ alignItems: "center" }}>
					{/* Logo */}
					<div className="mygrid-col-xs-12 mygrid-col-md-2">
						<div className="header_logo">
							<Link to="/">
								<HeaderLogo />
							</Link>
						</div>
					</div>

					{/* Navigation Menu */}
					<div className="mygrid-col-xs-12 mygrid-col-md-6">
						<nav className="header_navs_menu">
							<ul>
								{menuItems.map((item) => (
									<li
										key={item.path}
									>
										<Link
											className={window.location.pathname === item.path ? "active" : ""}
											to={item.path}
										>
											{item.name}
										</Link>
									</li>
								))}
							</ul>
						</nav>
					</div>

					{/* Other Buttons */}
					<div className="mygrid-col-xs-12 mygrid-col-md-4">
						<div className="menu_other_buttons">
							<div className="social_handles">
								<ul>
									<li>
										<a href={SOCIAL_MEDIA_LINKS.FACEBOOK} target="_blank" rel="noopener noreferrer">
											<FacebookIcon />
										</a>
									</li>
									<li>
										<a href={SOCIAL_MEDIA_LINKS.INSTAGRAM} target="_blank" rel="noopener noreferrer">
											<InstaIcon />
										</a>
									</li>
									<li>
										<a href={SOCIAL_MEDIA_LINKS.TIKTOK} target="_blank" rel="noopener noreferrer">
											<TiktokIcon />
										</a>
									</li>
								</ul>
							</div>

							<div className="portal_login_link">
								<Link to="/teacher/login">Portal Login</Link>
							</div>
							<div className="logins_btn">
								<CustomButton
									onClick={handleLoginClick}
									text={isLoggedIn ? "Dashboard" : "Login"}
									className="customs_btn"
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
		</HeaderContainer>
	);
};

export default Header;
